import { useEffect } from "react";

const BASE = "Paladin Professional Insurance Solutions";

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE}` : BASE;
    return () => { document.title = BASE; };
  }, [title]);
}
